import { render, staticRenderFns } from "./PersonalPropertyReparations.vue?vue&type=template&id=43e60b8a"
import script from "./PersonalPropertyReparations.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyReparations.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPropertyReparations.vue?vue&type=style&index=0&id=43e60b8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports